import { render } from "./LabeledDropDown.vue?vue&type=template&id=bff58956&scoped=true"
import script from "./LabeledDropDown.vue?vue&type=script&lang=js"
export * from "./LabeledDropDown.vue?vue&type=script&lang=js"

import "./LabeledDropDown.vue?vue&type=style&index=0&id=bff58956&lang=scss&scoped=true"
script.render = render
script.__scopeId = "data-v-bff58956"

export default script